<template>
  <div class="mobile-footer">
    <div class="subscribe-w">
      <Subscribe />
    </div>
    <FooterMenu />
    <ul class="icon-g">
      <li
        v-for="(item, index) in imgIcons"
        :key="index"
        class="icon-m"
        @click="goBank(item)"
      >
        <el-image :src="item.imgUrl" lazy alt="外链图标" />
      </li>
    </ul>
    <div class="mobile-footer-top">
      <div class="top-content">
        <div class="content-left">
          <p class="content-details">
            <span class="label">服务热线：</span>
            <a href="tel:4000-111-976" class="phone-link">4000-111-976</a>
          </p>
          <p class="content-details">
            <span class="label">邮箱：</span>
            <a href="mailto:sales@gwlaser.tech" class="phone-link">sales@gwlaser.tech</a>
          </p>
          <p class="content-details">
            <span class="label">地址：</span>
            <span>上海市青浦区华新镇华志路1388号中交数字智造港8号楼1-3层</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FooterMenu from './footerMenu.vue'
import Subscribe from './Subscribe.vue'
export default {
  name: 'MFooter',
  components: { Subscribe, FooterMenu },
  data() {
    return {
      imgIcons: [
        {
          imgUrl: require('@/assets/images/footer-wechart.svg'),
        },
        {
          imgUrl: require('@/assets/images/footer-toutiao.svg'),
          windowOpenUrl:
            'https://www.toutiao.com/c/user/token/MS4wLjABAAAAbUZGwKA_kcX2UDbN_UvwDJjk9GKqAg_Ob18s9p15fHZgKl8mLE5edevk0qsX5p9n/?',
        },
        {
          imgUrl: require('@/assets/images/footer-wechartV.svg'),
        },
        {
          imgUrl: require('@/assets/images/footer-douyin.svg'),
          windowOpenUrl:
            'https://www.douyin.com/user/MS4wLjABAAAAr7flbN4g2SeRdevBUdbI4cUq_-7yB8so40ZIRIcBtYo',
        },
      ],
    }
  },
  methods: {
    goBank(item) {
      if (item.windowOpenUrl) {
        window.open(item.windowOpenUrl, '_blank')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.mobile-footer {
  padding: 50px 0;
  .subscribe-w {
    margin-top: 20px;
  }
  &-top {
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(#e1e9ff, 0.55);
    .top-content {
      display: flex;
      justify-content: space-between;
      margin-top: 15px;
      .content-left {
        font-size: 14px;
        color: #fff;
        line-height: 20px;
        .content-details {
          margin-top: 10px;
        }
        .label {
          white-space: nowrap;
          display: inline-block;
        }
        .phone-link {
          color: #e9edff;
          text-decoration: none;
          word-break: break-all;
        }
        .phone-link:hover {
          color: #fff;
          text-decoration: underline;
        }
      }
    }
  }
  .icon-g {
    margin: 35px 0 25px 0;
    display: flex;
    .icon-m {
      margin-right: 15px;
      .el-image {
        width: 40px;
        height: 40px;
      }
    }
  }
  &-bottom {
    font-size: 16px;
    color: #e0e9ff;
    line-height: 22px;
    margin-top: 20px;
  }
}
@media (min-width: 1024px) and (max-width: 1200px) {
  .mobile-footer {
    &-top {
      border-bottom: none;
    }
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .mobile-footer {
    &-top {
      border-bottom: none;
    }
  }
}
@media (max-width: 768px) {
  .mobile-footer {
    padding: 50px 0 0 0;
    &-top {
      border-bottom: none;
      .top-content {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-top: 5px;
      }
    }
    &-bottom {
      font-size: 12px;
      margin-top: 0px;
    }
  }
}
</style>